// @flow

import FroalaEditor from 'froala-editor';

// The custom popup is defined inside a plugin (new or existing).
FroalaEditor.PLUGINS.sweetVideoIcon = function (editor) {
  // eslint-disable-next-line no-underscore-dangle
  function _init() {
    const command = 'insertVideo';

    FroalaEditor.DefineIcon(command, {
      NAME: 'video-camera',
      FA5NAME: 'video',
      SVG_KEY: 'insertVideo',
    });

    editor.$tb
      .find(`.fr-command[data-cmd="${command}"] i.fa-camera`)
      .removeClass('fa-camera')
      .addClass('fa-video');
  }

  return {_init};
};
